import { ProductBadge } from '~/components';
import { VENDORS_ROUTER } from '~/constants/router';
import ShoppingCartButton from '~/domains/cart/ShoppingCartButton';
import DeliveryFlag from '~/domains/delivery/DeliveryFlag';
import ProductPrice from '~/domains/products/components/ProductPrice';
import ProductImage from '~/domains/products/ProductImage';
import { useTrackProductEventProps } from '~/hooks/event';
import { useLinkComponent } from '~/hooks/mobileApp';
import type { OAISchema } from '~/types/openapi';

type Props = {
  inverse?: boolean;
  onClick?: (item: OAISchema['MarketSelectProductResponseV2']) => void;
  onCartClick?: (item: OAISchema['MarketSelectProductResponseV2']) => void; // TODO - 앰플리튜드 이벤트 한번 싹 정리할 떄, 제거 함.
  eventOption?: Record<string, unknown>;
  plusMembershipFullBadge?: boolean;
} & OAISchema['MarketSelectProductResponseV2'];

const WideProductCard = ({
  onClick,
  onCartClick,
  eventOption,
  ...data
}: Props) => {
  const LinkComponent = useLinkComponent();
  const {
    offerId,
    vendorId,
    mainImages,
    productName,
    isOutOfStock,
    status,
    inverse,
    mallName,
    deliveryFlags,
    isFreeShipping,
  } = data;
  const [props, { trackAddCart }] = useTrackProductEventProps(
    data,
    eventOption,
  );

  return (
    <LinkComponent href={VENDORS_ROUTER.productDetail(vendorId, offerId!)}>
      <div
        role="presentation"
        {...props}
        onClick={() => {
          props.onClick?.();
        }}
      >
        <ProductImage
          layout="fill"
          src={mainImages![0]}
          alt={productName}
          isOutOfStock={isOutOfStock}
          status={status}
          inverse={inverse}
          imageWrapperClassName="!aspect-w-[1.75]"
          rightBottom={
            <ShoppingCartButton
              className="mb-6 mr-8"
              onClick={() => {
                onClick?.(data);
                trackAddCart?.();
                onCartClick?.(data);
              }}
              item={data}
            />
          }
        />
        <div className="mb-4 text-hint typo-footnote300-regular">
          {mallName}
        </div>
        <div
          className="mb-4 line-clamp-2 whitespace-pre-line leading-[18px] text-normal"
          style={{ fontSize: '14px' }}
        >
          {productName}
        </div>
        <ProductPrice {...data} reverse />
        <div className="mt-4 flex items-center gap-4">
          <DeliveryFlag flags={deliveryFlags} className="mt-0" />
        </div>
        {isFreeShipping && (
          <div>
            <ProductBadge type="freeDelivery" />
          </div>
        )}
      </div>
    </LinkComponent>
  );
};

export default WideProductCard;
